import React, { useEffect } from "react";
import "./CalendlyEmbed.css";

export const CalendlyEmbed = ({ url, height = "700px", minHeight = "600px" }) => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  // Use demo/placeholder URL if none provided
  const calendlyUrl = url || "https://calendly.com/demo";

  return (
    <div className="calendly-embed-container">
      <div
        className="calendly-inline-widget"
        data-url={calendlyUrl}
        style={{
          minWidth: "320px",
          height: height,
          minHeight: minHeight
        }}
      ></div>
    </div>
  );
};

export default CalendlyEmbed;
